import { isEqual } from 'lodash'
import { FairlyPrioritizedUsers } from '@chilipiper/api-client/src/distribution/data-contracts'
import { DistributionData } from './queries'

type DraftPublishedComparisonDtoData = {
  readonly name?: unknown
  readonly teamRef?: { readonly id: unknown }
  readonly weights?: unknown
  readonly manualCalibration?: ReadonlyArray<{ readonly calibration: unknown }>
  readonly capping?: unknown
  readonly roundRobinKind?: unknown
  readonly handlingConfig?: unknown
}

const getFieldsToCompareDTO = (item: DraftPublishedComparisonDtoData) => ({
  name: item.name,
  teamId: item.teamRef?.id,
  weights: item.weights,
  // BE removes entries with 0 calibration
  manualCalibration: item.manualCalibration?.filter(item => item.calibration),
  capping: item.capping,
  roundRobinKind: item.roundRobinKind,
  handlingConfig: item.handlingConfig,
})

const getFieldsToCompareData = (item: DistributionData) => ({
  name: item.currentData.name,
  teamId: item.currentData.teamId,
  weights: item.currentData.weights,
  // BE removes entries with 0 calibration
  manualCalibration: item.currentData.manualCalibration?.filter(item => item.calibration),
  capping: item.currentData.capping,
  roundRobinKind: item.currentData.roundRobinKind,
  handlingConfig: item.currentData.handlingConfig,
})

const checkIfHasNewDraft = (draft: unknown, published?: unknown) => {
  return !isEqual(draft, published)
}

export const checkIfHasNewDraftDTO = (data: {
  draft: DraftPublishedComparisonDtoData
  published?: DraftPublishedComparisonDtoData
}) => {
  return checkIfHasNewDraft(
    getFieldsToCompareDTO(data.draft),
    data.published && getFieldsToCompareDTO(data.published)
  )
}

export const checkIfHasNewDraftModel = (data: {
  draft: DistributionData
  published?: DistributionData
}) => {
  return checkIfHasNewDraft(
    getFieldsToCompareData(data.draft),
    data.published && getFieldsToCompareData(data.published)
  )
}

export const getRoundRobinKind = (distribution: FairlyPrioritizedUsers) => {
  if (distribution.assignmentTypeConfig.type !== 'Meeting') {
    return undefined
  }

  return distribution.assignmentTypeConfig.handling.type
}

export const getReassignmentType = (distribution: FairlyPrioritizedUsers) => {
  if (distribution.assignmentTypeConfig.type !== 'Meeting') {
    return undefined
  }

  return distribution.assignmentTypeConfig.handling.type === 'Flexible'
    ? distribution.assignmentTypeConfig.handling.reassignmentType
    : 'SameUser'
}
